// extracted by mini-css-extract-plugin
export default {"root":"ProjectionModal_root__M9yy0"};